import { render, staticRenderFns } from "./CreateInvoiceConsultation.vue?vue&type=template&id=24db1784"
import script from "./CreateInvoiceConsultation.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceConsultation.vue?vue&type=script&lang=js"
import style0 from "./CreateInvoiceConsultation.vue?vue&type=style&index=0&id=24db1784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports